@if (showWithLayout) {
  <ng-container #cookie></ng-container>
  <ng-container #notifications> </ng-container>
  @if (showShell) {
    <app-header></app-header>
  }

  <div [@routeAnimations]="getRouteAnimationData()" class="main-content">
    @if (notFound) {
      <app-error404></app-error404>
    } @else {
      @if (enableMainRouting) {
        <router-outlet></router-outlet>
      }
      <router-outlet name="modal"></router-outlet>
      <router-outlet name="sideBar"></router-outlet>
    }
  </div>
  @if (showShell) {
    <div #footer [preRender]="false" (deferLoad)="initFooter()" style="min-height: 1px"></div>
  }
}
